
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum"

import * as appsettings from "../appsettings"
import * as main        from "../main"
import * as navigation  from "../navigation"
import * as viewmode    from "../viewmode"
import * as grid        from "../grid"; 

function upgradeLogType(applLogId: number): void {

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("ApplicationLogBook/Upgrade?applLogId=" + applLogId),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            var grid = $("#ApplicationLogBookGrid").data("kendoGrid");
            grid.dataSource.read();
        }
    });

}

export function initialize(gridId: string): void { 
    grid.loadGridOptions(gridId); 
}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ApplicationLogBookGridVM;

    // Show mode form 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("ApplicationLogBook/Show?applLogId=" + dataItem.ApplLogID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}

export function visibilityItem(dataItem: ApplicationLogBookGridVM): boolean {
    return dataItem.LogType == 1;
}

export function upgradeItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    var dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ApplicationLogBookGridVM;

    upgradeLogType(dataItem.ApplLogID);
}
